<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <SupplierForm
          v-model="supplier"
          title="Editace dodavatele"
          :loading="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import SupplierForm from '../../../components/product/SupplierForm'

export default {
  name: 'SupplierEdit',
  components: {
    SupplierForm,
  },
  data() {
    return {
      supplier: {},
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadSupplier()
  },
  methods: {
    ...mapActions({
      getSupplier: 'supplier/getSupplier',
      updateSupplier: 'supplier/updateSupplier',
    }),
    loadSupplier() {
      this.loading = true
      this.getSupplier(this.$route.params.supplierId)
        .then((response) => {
          this.supplier = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.saving = true
      this.updateSupplier(this.supplier)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
